/* Costack buy-path fixes - 15 Sep 2026
 * Additive. Remove the render line in snippets/costack-cro.liquid and this file
 * to roll everything back.
 * 1) Announcement bar threw a TypeError every 3s: Dawn reads currentSlide.classList
 *    where currentSlide is sliderItems[currentPage-1], undefined once currentPage
 *    runs past the slide count. A bad tick is now skipped, not thrown.
 * 2) Hero Add to basket did a full POST to /cart. The cart page has no free-delivery
 *    progress and no upsell; the drawer has both. Now adds over AJAX and opens the
 *    drawer, falling back to the old redirect if anything fails.
 * 3) Add all to cart failed silently when the page product was sold out.
 * 4) Sold-out cards pushed to the end of the collection grid.
 * 5) Add to cart wording standardised on Add to basket.
 * 6) The Shopify Forms 10% off teaser is pinned left-middle at z-index 2147483647,
 *    the maximum, so it cannot be out-stacked. Hidden while a buy surface is open.
 * 7) Cart drawer footer: Checkout first, Continue shopping under it, held at the
 *    bottom by sticky from a direct child of the scrolling .drawer__inner.
 * 8) The checkout button read "Check out" on desktop and "Checkout · £7.98" on
 *    mobile, because the label script is width-gated. One label everywhere now.
 * 9) SEARCH COULD NOT FIND THE TOP SELLERS. Shopify drops unavailable products from
 *    search, and five of the six best sellers are out of stock, so "jollof" returned
 *    the eBook, thyme and onion granules and no Jollof at all. Adding
 *    unavailable_products=show puts the real product back in the results.
 *10) On /cart the free-delivery bar, the upsell and the ebook line were invisible.
 *    THE FIRST FIX FOR THIS WAS WRONG. It set visibility:visible on the mount nodes,
 *    but those nodes live inside cart-drawer, which sits off-canvas: measured on live
 *    at left:1491 on a 1475px viewport. A visible node parked past the right edge of
 *    the screen is still a node nobody sees. They are now MOVED into the cart page's
 *    own totals column, above the checkout button. Moving preserves event listeners,
 *    so the Add buttons keep working. Re-runs every pass, so if an owning script
 *    recreates its mount inside the drawer the new one is pulled across and the
 *    stale copy dropped.
 */
(function () {
  'use strict';
  var LABEL = 'Add to basket';

  /* 9a. Predictive search must include sold-out products */
  (function () {
    var of = window.fetch;
    if (!of || of.cstkSearchPatched) return;
    function patched(input, init) {
      try {
        var url = (typeof input === 'string') ? input : (input && input.url) || '';
        if (url.indexOf('/search/suggest') > -1 && url.indexOf('unavailable_products') === -1) {
          var sep = url.indexOf('?') > -1 ? '&' : '?';
          var next = url + sep + 'resources%5Boptions%5D%5Bunavailable_products%5D=show&options%5Bunavailable_products%5D=show';
          input = (typeof input === 'string') ? next : new Request(next, input);
        }
      } catch (e) {}
      return of.apply(this, [input, init]);
    }
    patched.cstkSearchPatched = true;
    window.fetch = patched;
  })();

  /* 1. Announcement bar guard */
  function guard() {
    var C = window.customElements && customElements.get('slideshow-component');
    if (!C || !C.prototype) return false;
    if (C.prototype.cstkGuarded) return true;
    var orig = C.prototype.applyAnimationToAnnouncementBar;
    if (typeof orig !== 'function') return false;
    C.prototype.applyAnimationToAnnouncementBar = function () {
      try { return orig.apply(this, arguments); } catch (e) { return; }
    };
    C.prototype.cstkGuarded = true;
    return true;
  }
  if (!guard()) { var g = 0, gi = setInterval(function () { if (guard() || ++g > 60) clearInterval(gi); }, 150); }

  /* helpers */
  function drawer() { return document.querySelector('cart-drawer'); }
  function sectionsFor(d) {
    if (!d || typeof d.getSectionsToRender !== 'function') return null;
    try { return d.getSectionsToRender().map(function (s) { return s.id; }).join(','); } catch (e) { return null; }
  }
  function openDrawer(json) {
    var d = drawer();
    if (!d) return false;
    try {
      if (json && json.sections && typeof d.renderContents === 'function') {
        d.classList.remove('is-empty');
        d.renderContents(json);
        return true;
      }
    } catch (e) {}
    try { if (typeof d.open === 'function') { d.open(); return true; } } catch (e) {}
    return false;
  }

  /* 2. Hero add to basket: AJAX plus drawer */
  function bindHero() {
    var form = document.getElementById('cstkhb-form');
    if (!form || form.cstkBound) return;
    form.cstkBound = true;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var was = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
      var body = new FormData(form);
      var d = drawer(), ids = sectionsFor(d);
      if (ids) { body.append('sections', ids); body.append('sections_url', window.location.pathname); }
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: body })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok || res.j.status) { window.location.href = '/cart'; return; }
          if (!openDrawer(res.j)) window.location.href = '/cart';
        })
        .catch(function () { form.submit(); })
        .then(function () { if (btn) { btn.disabled = false; btn.textContent = was; } });
    });
  }

  /* 3. Add all to cart: never fail silently */
  var baseAvail = null;
  function baseAvailable(id) {
    if (baseAvail !== null) return Promise.resolve(baseAvail);
    var m = location.pathname.split('/products/')[1];
    if (!m) { baseAvail = true; return Promise.resolve(true); }
    var handle = m.split('/')[0].split('?')[0];
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var v = p.variants.filter(function (x) { return x.id === id; })[0];
        baseAvail = v ? !!v.available : true;
        return baseAvail;
      })
      .catch(function () { baseAvail = true; return true; });
  }
  function say(form, text) {
    var box = form.querySelector('.cstk-pair-msg');
    if (!box) {
      box = document.createElement('p');
      box.className = 'cstk-pair-msg';
      box.setAttribute('role', 'status');
      box.setAttribute('style', 'margin:10px 0 0;font-size:13px;font-weight:600;color:#9a3412;width:100%;');
      form.appendChild(box);
    }
    box.textContent = text || '';
  }
  function post(items) {
    var payload = { items: items.map(function (id) { return { id: id, quantity: 1 }; }) };
    var ids = sectionsFor(drawer());
    if (ids) { payload.sections = ids; payload.sections_url = window.location.pathname; }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); });
  }
  function pairAdd(btn) {
    var form = document.getElementById('CostackPairForm');
    if (!form) return;
    var baseId = parseInt(form.getAttribute('data-base-variant'), 10);
    var pairs = [];
    Array.prototype.forEach.call(form.querySelectorAll('input[name="pair_ids[]"]:checked'), function (cb) {
      pairs.push(parseInt(cb.value, 10));
    });
    say(form, '');
    btn.setAttribute('disabled', 'disabled');
    btn.textContent = 'Adding...';
    function done(label, msg) {
      btn.textContent = label;
      say(form, msg || '');
      setTimeout(function () { btn.textContent = 'Add all to cart'; btn.removeAttribute('disabled'); }, 1800);
    }
    function landed(json, msg) {
      done('Added', msg || '');
      if (!openDrawer(json)) window.location.href = '/cart';
    }
    baseAvailable(baseId).then(function (ok) {
      var items = ok ? [baseId].concat(pairs) : pairs.slice();
      if (!items.length) { done('Add all to cart', 'This blend is sold out. Tick one of the matched blends instead.'); return; }
      return post(items).then(function (res) {
        if (res.ok && !res.j.status) {
          landed(res.j, ok ? '' : 'Added the matched blends. This blend is sold out.');
          return;
        }
        if (ok && pairs.length) {
          return post(pairs).then(function (r2) {
            if (r2.ok && !r2.j.status) landed(r2.j, 'Added the matched blends. This blend could not be added.');
            else done('Try again', (r2.j && r2.j.description) || 'Those items are not available right now.');
          });
        }
        done('Try again', (res.j && res.j.description) || 'Those items are not available right now.');
      });
    }).catch(function () { done('Try again', 'Something went wrong. Please try again.'); });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('#CostackPairAdd') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    pairAdd(btn);
  }, true);

  /* 4. Sold-out last in the grid */
  function soldOut(li) {
    var b = li.querySelectorAll('.badge, .card__badge');
    for (var i = 0; i < b.length; i++) { if (/sold\s*out/i.test(b[i].textContent || '')) return true; }
    return false;
  }
  function reorder() {
    var grids = document.querySelectorAll('ul.product-grid, ul#product-grid');
    for (var n = 0; n < grids.length; n++) {
      var kids = grids[n].children;
      for (var i = 0; i < kids.length; i++) {
        var li = kids[i];
        if (li.nodeType !== 1) continue;
        if (soldOut(li)) { li.style.order = '2'; li.classList.add('cstk-oos'); }
        else if (li.classList.contains('cstk-oos')) { li.style.order = ''; li.classList.remove('cstk-oos'); }
      }
    }
  }

  /* 5. One word for the buy button */
  function relabel() {
    var els = document.querySelectorAll('.bundle-btn, .bundle2-btn, .ck-cta-btn, .costack-satc-btn, .product-form__submit span');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.children.length) continue;
      var t = (el.textContent || '').trim();
      if (t !== LABEL && /^add to (cart|basket)$/i.test(t)) el.textContent = LABEL;
    }
  }

  /* 6. Keep the 10% off teaser clear of the buy button */
  function buySurfaceOpen() {
    if (/^\/cart/.test(location.pathname)) return true;
    if (document.querySelector('quick-add-modal[open]')) return true;
    var d = document.querySelector('cart-drawer');
    if (d && d.classList.contains('active')) return true;
    return false;
  }
  function formsGuard() {
    document.documentElement.classList.toggle('cstk-hide-forms', buySurfaceOpen());
  }

  /* 7. Checkout first, Continue shopping under it, held at the bottom */
  function pinCartCtas() {
    var d = drawer();
    if (!d) return;
    var inner = d.querySelector('.drawer__inner');
    var ctas = d.querySelector('.cart__ctas');
    if (!inner || !ctas) return;
    var cont = d.querySelector('.cstk-continue');
    if (cont && cont.parentElement !== ctas) ctas.appendChild(cont);
    if (ctas.parentElement !== inner) inner.appendChild(ctas);
    ctas.classList.add('cstk-ctas-stacked');
    var foot = d.querySelector('.drawer__footer');
    if (foot) foot.style.setProperty('padding-bottom', '0px', 'important');
  }

  /* 8. One checkout label, with the total, at every width */
  function checkoutLabel() {
    var d = drawer();
    if (!d) return;
    var btn = d.querySelector('.cart__ctas button[name="checkout"]');
    if (!btn || btn.children.length) return;
    var tv = d.querySelector('.totals__total-value');
    var amount = tv ? (tv.textContent || '').trim().replace(/\s*[A-Za-z]{3}\s*$/, '').trim() : '';
    var want = amount ? 'Checkout · ' + amount : 'Checkout';
    var now = (btn.textContent || '').replace(/\s+/g, ' ').trim();
    if (now !== want) btn.textContent = want;
  }

  /* 9b. Carry the same option on the search form */
  function searchFormOption() {
    var forms = document.querySelectorAll('form[action="/search"], form[action$="/search"]');
    for (var i = 0; i < forms.length; i++) {
      var f = forms[i];
      if (f.querySelector('input[name="options[unavailable_products]"]')) continue;
      var inp = document.createElement('input');
      inp.type = 'hidden';
      inp.name = 'options[unavailable_products]';
      inp.value = 'show';
      f.appendChild(inp);
    }
  }

  /* 10. Move the injected cart blocks onto the visible part of /cart */
  function cartPageHost() {
    var col = document.querySelector('#main-cart-footer .cart__blocks')
           || document.querySelector('#main-cart-footer .cart__footer')
           || document.querySelector('#main-cart-footer');
    if (!col) return null;
    var host = col.querySelector(':scope > .cstk-cartpage-host');
    if (host) return host;
    host = document.createElement('div');
    host.className = 'cstk-cartpage-host';
    host.setAttribute('style', 'display:block;visibility:visible;margin:0 0 14px;');
    col.insertBefore(host, col.firstChild);
    return host;
  }
  function relocate(sel, host) {
    var nodes = document.querySelectorAll(sel);
    var fresh = null;
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].closest && nodes[i].closest('cart-drawer')) { fresh = nodes[i]; break; }
    }
    if (!fresh) return;
    var stale = host.querySelector(sel);
    if (stale && stale !== fresh && stale.parentNode) stale.parentNode.removeChild(stale);
    fresh.style.setProperty('visibility', 'visible', 'important');
    host.appendChild(fresh);
  }
  function cartPageMounts() {
    if (!/^\/cart/.test(location.pathname)) return;
    var host = cartPageHost();
    if (!host) return;
    relocate('.costack-bar-mount', host);
    relocate('.costack-gapcloser-mount', host);
    relocate('[data-cstk-ebook-cart]', host);
  }

  function pass() {
    bindHero(); reorder(); relabel(); formsGuard();
    pinCartCtas(); checkoutLabel(); searchFormOption(); cartPageMounts();
  }

  var queued = false;
  function tick() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; pass(); }, 60);
  }
  function start() {
    pass();
    try { new MutationObserver(tick).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'class'] }); } catch (e) {}
    [400, 1200, 2500, 5000].forEach(function (t) { setTimeout(pass, t); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
